import { getDatabase, ref, get, update, serverTimestamp } from "firebase/database";
import { getInquiryDataById, getUserByID, updateInquiryStatus, sendSMS } from "../utils";

/**
 * Send accept offer message after successful payment
 * This function handles sending messages and notifications after an offer is accepted and payment is completed
 */
export const sendAcceptOfferMessageAfterPayment = async () => {
  try {
    // Retrieve stored data from localStorage
    const acceptOfferDataString = localStorage.getItem('acceptOfferData');
    if (!acceptOfferDataString) {
      console.error("No accept offer data found in localStorage");
      return;
    }

    const acceptOfferData = JSON.parse(acceptOfferDataString);
    const { 
      inquiryId, 
      chatId, 
      senderId, 
      receiverId, 
      listingId, 
      listingTitle,
      otherUserPhone,
      renterName
    } = acceptOfferData;

    // Get inquiry data
    const inquiryData = await getInquiryDataById(inquiryId);
    if (!inquiryData || !inquiryData.offerData) {
      console.error("Invalid inquiry data");
      return;
    }

    // Create message content
    const offerMessage = `Hey, I have accepted the offer, quoted <span style="font-weight: bold;">$${inquiryData.offerData.offerPrice}</span>.
    LineBreakLooking forward to see you on ${inquiryData.offerData.offeredDate} at ${inquiryData.offerData.offeredTime}.`;

    const offerMessageMobile = `Hey, I have accepted the offer, quoted $${inquiryData.offerData.offerPrice}.  
Looking forward to seeing you on ${inquiryData.offerData.offeredDate} at ${inquiryData.offerData.offeredTime}.`;

    const database = getDatabase();
    const chatRef = ref(database, `chats/${chatId}`);

    // Get current chat data
    const chatSnapshot = await get(chatRef);
    if (!chatSnapshot.exists()) {
      console.error("Chat not found");
      return;
    }

    // Create message data
    const messageData = {
      senderId,
      receiverId,
      message: offerMessage,
      messageMobile: offerMessageMobile,
      inquiryId,
      listingId,
      offerAccepted: 1,
      timestamp: serverTimestamp(),
    };

    // Send SMS notifications
    const renterSmsBody = `Your offer for ${listingTitle} has been accepted.\n\n Your payment has been processed successfully.`;
    sendSMS(otherUserPhone, renterSmsBody);

    const ownerDetails = await getUserByID(receiverId);
    const ownerSmsBody = `Your offer for ${listingTitle} has been accepted by ${renterName}.\n\n Payment has been received.`;
    sendSMS(ownerDetails.phone, ownerSmsBody);

    // Update inquiry status
    await updateInquiryStatus(inquiryId, "Accepted");

    // Add message to chat
    await update(chatRef, {
      messages: [...chatSnapshot.val().messages, messageData],
    });

    // Clear the stored data after successful processing
    localStorage.removeItem('acceptOfferData');
    
    console.log("Accept offer message sent successfully after payment");
    return true;
  } catch (error) {
    console.error("Error sending accept offer message after payment:", error);
    return false;
  }
};
